<template>
  <el-card class="box-card">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
        >Panel</el-breadcrumb-item
      >
      <el-breadcrumb-item
        :to="{ path: '/dashboard/' + $route.params.db + '/nomina' }"
        >Nominas</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="$route.params.id"
        >Editando Nomina</el-breadcrumb-item
      >
      <el-breadcrumb-item v-else>Nueva Nómina</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <h2>{{ form.title }}</h2>
    <el-form
      @submit.native.prevent="submit"
      ref="form"
      label-position="top"
      id="form"
    >
      <el-row type="flex" justify="space-between">
        <el-col>
          <el-form-item label="Fecha">
            <el-date-picker
              v-model="form.fecha"
              type="date"
              placeholder="Selecciona una fecha"
              format="dd/MM/yyyy"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col>
          <el-form-item label="Pdf nominas">
            <el-upload
              :key="reload_upload"
              ref="file"
              action
              :auto-upload="false"
              :multiple="false"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :file-list="documento"
              :limit="1"
            >
              <el-button size="small" type="primary"
                >Clic para cargar archivo</el-button
              >
            </el-upload>
          </el-form-item>
        </el-col>

        <el-col v-if="show_procesar">
          <el-form-item label="Procesar nomina">
            <el-button
              class="el-button el-button--primary"
              @click="procesar()"
              v-loading.fullscreen.lock="fullscreenLoading"
              >Procesar pdf</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template v-if="showTabla">
      <app-table-paginate
        :key="reload_table"
        :routeEdit="routeEdit"
        :tableQuery="tableData"
        :tableColumns="tableColumns"
        :table="tableDelete"
        :preview="preview"
        :search="true"
      ></app-table-paginate>
    </template>

    <el-row>
      <el-col :span="24">
        <button type="submit" class="el-button el-button--primary" form="form">
          <span>Guardar</span>
        </button>

        <el-button v-if="!$route.params.section_id" @click="close()"
          >Cancelar</el-button
        >
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import notificationform from "@/components/Dashboard/home/notificationform";
import modalAddAuth from "@/components/Dashboard/Modals/addAuth";

import ApiService from "@/common/api.service";
import { INTRANET_URL, API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import moment from "moment-timezone";

import {
  FECTH_TIPO_TEMPLATE_DESKTOP,
  FECTH_PAGINA_ACTIVA,
  FECTH_PAGE,
} from "@/store/actions.type";
import { SET_TIPO_TEMPLATE_DESKTOP } from "@/store/mutations.type";

export default {
  name: "NominaForm",
  components: {
    "app-notification-form": notificationform,
    "app-table-paginate": tablaConPaginador,
    "app-modal-add-auth": modalAddAuth,
  },
  async created() {
    if (this.$route.params.id) this.init();
  },
  data() {
    return {
      reload_table: 0,
      fullscreenLoading: false,
      show_procesar: false,
      reload_upload: 0,
      documento: [],
      pickerOptions1: {
        firstDayOfWeek: 1,
      },
      showEditPermisos: true,

      // show,s
      showTabla: false,

      // modal
      tableAuth: false,
      idAuth: false,

      // form
      id: null,
      form: {
        fecha: null,
        pdf: "",
      },

      templates: null,
      errorTitle: false,

      // paginate
      tableData: [],
      routeEdit: false,
      tableColumns: [
        {
          label: "Usuario",
          prop: "users",
        },
        {
          label: "Nomina",
          prop: "pdf",
          type: "file",
        },
        {
          label: "Firmado",
          prop: "is_firmado",
          type: "switch",
        },
      ],
      tableDelete: false,
      preview: false,

      // notification
      notification: false,
      notification_id: false,
    };
  },
  methods: {
    async init() {
      this.id = this.$route.params.id;
      await this.getDesktop();
    },
    handleRemove(file) {
      this.documento = [];
      this.form.pdf = "";
    },
    handleChange(file) {
      this.documento = [{ file, field: "pdf" }];
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },
    async procesar() {
      this.fullscreenLoading = true;
      const response = await ApiService.post("dashboard/nominas/procesa", {
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.id,
      });
      this.fullscreenLoading = false;
      this.show_procesar = false;
      this.getDesktop();
    },
    async getDesktop() {
      const response = await ApiService.post("dashboard/table", {
        table: "nominas_main_pdf",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.id,
      });
      this.form = response.data;
      if (this.form.pdf != "") {
        this.documento[0] = {
          url: API_UPLOADS + this.form.pdf,
          name: "Nomina",
          status: "success",
        };
        this.reload_upload++;
      }
      if (this.form.procesado == 2) {
        this.show_procesar = true;
      } else {
        const b = await ApiService.post("dashboard/listtable", {
          table: "nominas_pdf_usuarios",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          relationship: [
            {
              relationship: {
                table: "users",
                key: "id",
                options: [
                  {
                    key: "name",
                  },
                  {
                    key: "last_name",
                  },
                ],
              },
            },
          ],
          header: [
            {
              title: "Nomina",
              path: "pdf",
              type: "file",
              key: false,
              options: [],
            },
            {
              title: "Firmado",
              path: "is_firmado",
              type: "switch",
              key: false,
              options: [],
            },
          ],
          row: "id_nomina",
          id: this.id,
        });

        if (b.data != "Algo ha fallado") {
          b.data.forEach((element) => {
            element.pdf = API_UPLOADS + element.pdf;
          });
        }

        this.tableData = b.data;
        this.showTabla = true;
      }
    },

    async uploadFile(data) {
      const response = await ApiService.post("upload/nominas", data);
      return response.data;
    },
    async submit() {
      if (this.form.fecha == "") {
        this.$message({
          type: "error",
          message: "El campo Fecha es obligatorio",
        });
        return false;
      }
      if (this.documento.length > 0) {
        for (const i of this.documento) {
          if (i.file.size) {
            let data = new FormData();
            data.append("file", i.file.raw);
            data.append("type", "file");
            data.append("domain", localStorage.getItem("project"));
            let documento = await this.uploadFile(data);
            this.form.pdf = documento;
          }
        }
      }
      this.form.fecha = moment(this.form.fecha)
        .tz("Europe/Madrid")
        .format("YYYY-MM-DD");
      const response = await ApiService.post("dashboard/editform", {
        table: "nominas_main_pdf",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.form,
        id: this.$route.params.id,
      });

      this.$router.replace("/dashboard/" + this.$route.params.db + "/nomina");
    },

    async close() {
      await this.$router.replace(
        "/dashboard/" + this.$route.params.db + "/nomina"
      );
    },
    loading() {
      this.fullscreenLoading = true;
    },
  },
};
</script>
<style>
.disabled {
  background-color: #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/nominas/form.vue